import { zhTWXinyi } from './zh-TW.xinyi';
import { zhTWXimen } from './zh-TW.ximen';
import { zhTWCks } from './zh-TW.cks';
import { zhTWHlcity } from './zh-TW.hlcity';
import { zhTWTaroko } from './zh-TW.taroko';
import { zhTWStory } from './zh-TW.story';
import { zhTWAirport } from './zh-TW.airport';
import { zhTWKaohsiung } from './zh-TW.kaohsiung';
import { zhTWTainan } from './zh-TW.tainan';
import { zhTWBarcelona } from './zh-TW.barcelona';
import { zhTWGuide } from './zh-TW.guide';
import { zhTWWorld3 } from './zh-TW.world3';
import { zhTWTrips } from './zh-TW.trips';
import { zhTWSky } from './zh-TW.sky';
import { zhTWFamily } from './zh-TW.family';
import { zhTWClassroom } from './zh-TW.classroom';
import { zhTWLife } from './zh-TW.life';
import type { Messages } from './en';
import { zhTWTalks3 } from './zh-TW.talks3';
import { zhTWTreasure } from './zh-TW.treasure';
import { zhTWPlaces } from './zh-TW.places';
import { zhTWArcade } from './zh-TW.arcade';
import { zhTWTalks } from './zh-TW.talks';
import { zhTWExtra } from './zh-TW.extra';

export const zhTW: Messages = {
  meta: {
    title: '校園生活大冒險：今天也不能倒下！',
  },

  start: {
    title: '校園生活大冒險',
    tagline: '今天也不能倒下！',
    blurb: '國中輔導小天使的一週：上學、家人、朋友，還有好多好多杯茶。',
    language: '語言',
    look: '你的造型',
    pet: '選一隻陪伴你的寵物',
    birthdays: '親友生日（玩家自己填）',
    you: '我',
    mom: '媽媽',
    dad: '爸爸',
    emma: 'Emma',
    month: '月',
    day: '日',
    newGame: '開始新遊戲',
    continue: '繼續生活冒險',
    continueInfo: (week: number, day: string, time: string) => `第 ${week} 週・${day}・${time}`,
    confirmNew: '要開始新遊戲嗎？目前的存檔進度會消失喔。',
    controls: '移動：方向鍵／WASD／點擊　互動：空白鍵／E　跳躍：空白鍵／X／🦘　地圖：M　任務：Q　選單：Esc',
  },

  looks: ['棕色短髮', '黑色長髮', '紅色捲髮', '金色馬尾'],

  pets: {
    rabbit: '小白兔',
    cat: '貓咪',
    dog: '柴犬',
    hedgehog: '小刺蝟',
    hamster: '倉鼠',
    croc: '小鱷魚',
    fish: '熱帶魚',
    dino: '小恐龍',
  },

  days: {
    fri: { name: '週五', kind: '平日' },
    sat: { name: '週六', kind: '週末' },
    sun: { name: '週日', kind: '母親節' },
  },

  zones: {
    counsel: '輔導室',
    corridor: '專科教室',
    yard: '中庭',
    field: '操場',
    home: '溫馨的家',
    schoolGate: '校園',
    street: '大街',
    store: '街角便利商店',
    park: '公園',
    neighborhood: '住宅區',
    classroom: '八年三班',
    library: '圖書館',
    artRoom: '美術音樂教室',
    lobby: '穿堂',
    cafeteria: '餐廳',
    restroom: '洗手間',
  },

  hud: {
    week: (n: number) => `第 ${n} 週`,
    untilBed: (h: number, mm: string) => `離睡覺還有 ${h}:${mm}`,
    energy: '精力',
    mood: '心情',
    study: '學力',
    bladder: '尿意',
    stars: '學力星',
    coins: '榮譽金幣',
  },

  tools: {
    english: '英文跟讀',
    radio: '英文廣播',
    art: '美感訓練',
    puzzle: '拼圖',
    blocks: '方塊堆疊',
    social: 'PixelBook',
    party: '派對',
  },

  side: { todo: '今日清單', bag: '背包', shop: '福利小舖', phone: '手機', menu: '選單', journal: '日誌', quests: '任務', map: '地圖' },

  common: {
    ok: '好',
    close: '關閉',
    back: '返回',
    gotIt: '知道了',
    cancel: '取消',
    yes: '是',
    no: '否',
    minutes: (n: number) => `${n} 分鐘`,
    alreadyToday: '今天已經做過囉，換點別的試試吧！',
    me: '我',
    thoughts: '（心聲）',
    breathe: '深呼吸，今天也要元氣滿滿！',
    looking: (label: string) => `你正在查看${label}。`,
    stars: (n: number) => `${n > 0 ? '+' : ''}${n}⭐`,
    coins: (n: number) => `${n > 0 ? '+' : ''}${n}🪙`,
    closedToday: '今天這裡沒有人，週末學校不上課喔。',
    schoolClosed: '週末學校沒有開放喔。',
  },

  objectives: {
    title: '今日目標',
    allDone: '今日目標全部完成！好好享受剩下的時光吧。',
    bonus: (stars: number) => `今日目標全數達成！額外獎勵 +${stars}⭐`,
    fri: {
      xiaoyu: '在輔導室陪伴安慰小宇',
      teacher: '向林老師報告小宇的狀況',
      log: '在電腦桌寫輔導小天使紀錄',
      homework: '回家寫功課',
    },
    sat: {
      cookies: '在家烤蔓越莓餅乾',
      picnic: '和 Emma 在中庭野餐',
      dishes: '洗碗盤',
      sister: '唸故事給妹妹聽',
    },
    sun: {
      strawberries: '到福利小舖買草莓',
      cake: '烤一個草莓戚風蛋糕',
      giveCake: '把蛋糕送給媽媽',
      callDad: '打電話請爸爸回家吃晚餐',
    },
  },

  chores: {
    title: '好孩子自律常規',
    hint: '主動分擔家務，媽媽都看在眼裡喔！',
    shoes: '書包鞋子歸位整齊',
    dishes: '清洗便當盒與碗盤',
    sister: '陪妹妹讀繪本講故事',
    homework: '完成作業與英文跟讀',
    shower: '洗溫水澡、換上乾淨睡衣',
    callDad: '打電話催爸爸回家吃晚餐',
    allTitle: '🌟 今日模範好孩子 🌟',
    allText: '恭喜你！今天完成了所有放學自律常規！媽媽給了你一個大大的擁抱，還有零用錢獎勵！',
    allClaim: '謝謝媽媽！（+20⭐ +50🪙）',
  },

  status: {
    tired: '你累壞了……快去喝點東西或找個地方休息。',
    bladderWarn: '好想上廁所！快去洗手間！',
    accident: '糟糕……來不及去洗手間了，好丟臉喔。',
    collapseTitle: '你倒下了！',
    collapseText: '眼前一黑……兩個小時後你在沙發上醒來。記得多喝水、多休息！',
    xiaoyuComing: '小宇正往輔導室走來……',
    xiaoyuSits: '小宇拉開椅子坐下了。',
    familyTime: '溫馨陪伴時光！心情加分',
    lateNight: '時間不早了，回家上床睡覺結束這一天吧。',
  },

  summary: {
    title: (day: string) => `${day}結束了`,
    starsToday: '獲得的星星',
    goals: '完成的目標',
    chores: '自律常規',
    collapses: '倒下次數',
    mood: '最終心情',
    momLove: '媽媽好感度',
    next: '睡覺，迎接新的一天',
    weekTitle: (week: number) => `第 ${week} 週完成！`,
    weekText: (stars: number, rank: string) => `總星星數：${stars}。評價：${rank}。`,
    ranks: ['再接再厲', '懂事好孩子', '輔導小天使之星', '校園傳說'],
    nextWeek: '開始下一週',
  },

  sleep: {
    label: '床',
    title: '溫暖的小床',
    early: '現在睡覺還太早了，要不要小睡一下？',
    nap: '小睡 30 分鐘（精力回復）',
    sleep: '上床睡覺（結束今天）',
    stay: '還不要',
  },

  menu: {
    title: '暫停選單',
    resume: '繼續遊戲',
    language: '語言',
    sound: (on: boolean) => `音效：${on ? '開' : '關'}`,
    voice: (on: boolean) => `語音：${on ? '開' : '關'}`,
    endDay: '直接結束今天',
    endDayConfirm: '要直接跳到今天結束嗎？',
    newGame: '開始新遊戲',
    save: '儲存進度',
    saved: '遊戲已存檔。',
  },

  bag: {
    title: '🎒 我的背包',
    use: '使用',
    empty: '背包空空的。',
    items: {
      tea: { name: '茶包', desc: '飲用：精力 +12' },
      orange: { name: '新鮮蜜柑', desc: '食用：精力 +10' },
      candy: { name: '水果喉糖', desc: '食用：心情 +4。也很適合送人。' },
      cookies: { name: '蔓越莓手工餅乾', desc: '食用：精力 +8、心情 +6。最適合分享。' },
      cake: { name: '草莓戚風蛋糕', desc: '充滿心意的禮物。' },
      strawberries: { name: '草莓', desc: '烤蛋糕用的。' },
      book: { name: '精裝繪本', desc: '講故事時間用。' },
      water: { name: '隨身水壺', desc: '飲用：精力 +6（可到飲水機裝水）' },
      riceBall: { name: '飯糰', desc: '食用：精力 +15' },
      juice: { name: '鋁箔包果汁', desc: '飲用：精力 +10' },
      atlas: { name: '世界地圖集', desc: '圖書館失蹤的那本地圖集。' },
      kite: { name: '風箏', desc: '小寶的紅色風箏。' },
      kitten: { name: '小貓麻糬', desc: '李奶奶的小貓，一直跟在你身後！' },
      letter: { name: '信', desc: '媽媽要給李奶奶的信。' },
    },
    used: (name: string) => `使用了：${name}`,
    emptyBottle: '水壺空了，去飲水機裝滿吧。',
  },

  shop: {
    title: '🛒 福利小舖',
    hint: '用金幣購買。幫忙做家事、解開拼圖都能賺金幣喔。',
    buy: '購買',
    bought: (name: string) => `兌換成功：${name}`,
    poor: '金幣不夠喔！',
  },

  objects: {
    desk: '輔導小天使電腦桌',
    tea: '茶水吧',
    water: '透亮飲水機',
    shelf: '雙層書架',
    plant: '觀葉盆栽',
    sofa: '沙發',
    toilet: '洗手間',
    easel: '美術畫架',
    chineseDesk: '中文造句桌',
    piano: '音樂大鋼琴',
    board: '公佈欄',
    field: '外野',
    bench: '長椅',
    shoes: '玄關鞋櫃',
    sink: '廚房洗碗槽',
    oven: '烘焙烤箱',
    homeDesk: '自律書桌',
    bath: '溫暖浴室',
    bed: '床',
    picnic: '野餐墊',
    atlasDesk: '學生課桌',
    libShelf: '圖書館書架',
    vending: '自動販賣機',
    canteen: '午餐供餐台',
    busStop: '公車站',
    mailbox: '信箱',
    pond: '池塘',
    bush: '樹叢',
    kiteTree: '大樹',
    swing: '盪鞦韆',
    fridge: '冰箱',
    tv: '電視',
    shopCounter: '櫃檯',
  },

  npc: {
    chunbo: '春伯',
    emma: 'Emma',
    teacher: '林老師',
    xiaoyu: '小宇',
    mom: '媽媽',
    sister: '妹妹',
    dad: '爸爸',
    librarian: '王阿姨',
    rain: '小雨',
    coach: '徐教練',
    clerk: '阿凱',
    grandma: '李奶奶',
    bo: '小寶',
    cat: '貓咪',
  },

  desk: {
    text: '螢幕顯示著輔導小天使的值班表和今天的紀錄。',
    log: '寫輔導小天使紀錄',
    logDone: '紀錄已儲存：「八年級的小宇因家裡的狀況常感疲倦，請多一點耐心與溫暖。」',
    english: '開啟英文影子跟讀',
    schedule: '查看今日目標',
  },

  tea: {
    text: '熱水壺冒著裊裊熱氣，飄來麥茶和可可的香味。',
    drink: '泡一杯熱可可（精力 +18）',
    drinkToast: '暖暖甜甜的，整個人精神百倍！',
    share: '泡一整壺分享給大家（茶包 +3）',
    shareToast: '你包好了 3 個茶包，可以送給別人。',
    watch: '欣賞茶水慢慢滴落（心情 +6）',
    watchToast: '滴答……滴答……心靈好療癒。',
  },

  water: {
    text: '透亮水藍色的桶身清澈晶瑩，冷熱雙龍頭隨時能出水。',
    cold: '喝一杯冰水（精力 +6）',
    coldToast: '咕嚕咕嚕～沁涼透心脾！',
    hot: '泡一杯熱茶（心情 +8）',
    hotToast: '暖呼呼的熱茶，整個人都溫暖起來。',
    refill: '把隨身水壺裝滿',
    refillToast: '水壺已裝滿！',
  },

  shelf: {
    text: '書架上整齊陳列著紅、藍、綠、金的彩色書本。',
    read: '閱讀《自律心理學》（學力 +8）',
    readToast: '自律不是約束，而是掌控人生的能力！',
    borrow: '借一本繪本回家唸給妹妹聽',
    borrowToast: '獲得一本精裝繪本！',
    english: '開啟英文影子跟讀',
  },

  plant: {
    text: '赤陶紅盆裡，深綠、翠綠、嫩綠三層葉片蓬鬆茂盛。',
    water: '用小噴壺替葉片澆水（心情 +6）',
    waterToast: '水滴在綠葉上晶瑩剔透！',
    prune: '細心修剪老葉、鬆土照料',
    pruneToast: '盆栽被照顧得好健康、好有精神！',
  },

  sofa: {
    text: '柔軟的米色長沙發，最適合暫時小憩一下。',
    nap: '閉目養神 20 分鐘（精力、心情回復）',
    napToast: '深呼吸放鬆，身心重獲平靜！',
  },

  toilet: {
    notNeeded: '目前不需要使用洗手間。',
    done: '呼～通體舒暢！',
  },

  art: {
    title: '美術教室・美感畫架',
    text: '畫架上標註著**美感訓練六大核心面向**：\n1. **形狀**：輪廓與比例\n2. **色彩**：色調搭配與冷暖平衡\n3. **質感**：木紋、織理與觸感\n4. **構圖**：平衡、留白與節奏\n5. **結構**：秩序與支撐\n6. **日常實踐**：觀察 ➔ 蒐集 ➔ 模仿 ➔ 創造',
    quiz: '🎨 色彩混色測驗',
    quizQ: '若將「鈷藍色」與「檸檬黃」等比例混合，會調配出什麼顏色？',
    quizA: ['生機盎然的「草綠色」', '沉靜優雅的「深紫色」', '明亮溫暖的「柑橘橙」'],
    quizRight: '答對了！藍加黃調出綠色！',
    quizWrong: ['那是藍加紅喔，再想想！', '那是紅加黃喔！'],
    steps: '🖼️ 日常美感練習四步驟',
    stepsText: '① **觀察**：主動分析平衡、對比與和諧\n② **蒐集**：隨手拍照記錄喜歡的色彩與排版\n③ **模仿**：把欣賞的色調放進穿搭與房間佈置\n④ **創造**：發展出屬於自己的獨特風格！',
    stepsClaim: '記住了！（+5⭐）',
  },

  writing: {
    title: '中文造句桌',
    text: '黑板上寫著各種關聯詞句型。',
    a: '✍️ 「雖然……但是……」轉折句型',
    aQ: '請選出語意通順的句子：',
    aGood: '雖然外面的雨下得很大，但是我們依然充滿熱情、準時到校。',
    aBad: '雖然我吃了早餐，但是肚子覺得很飽。',
    aRight: '通順又合邏輯！',
    aWrong: '語意轉折有點不通，再想想喔！',
    b: '✍️ 「不僅……而且……」遞進句型',
    bQ: '請選出最好的句子：',
    bGood: '小宇不僅說出了心裡的煩惱，而且主動開口朗讀英文！',
    bBad: '小宇不僅很累，而且天空是藍色的。',
    bRight: '非常優秀的遞進佳句！',
    bWrong: '前後兩句沒有層層遞進的關係喔。',
  },

  piano: {
    title: '音樂教室・大鋼琴',
    text: '琴鍵在陽光下泛著純黑與象牙白的光澤。',
    free: '🎹 自由彈奏',
    freeText: '點選琴鍵發聲：',
    played: (note: string) => `♪ ${note}`,
    finish: '完成練習（+3⭐）',
    ear: '👂 絕對音感聽音測驗',
    earQ: '剛才響起的是哪個音？',
    replay: '🔁 再聽一次',
    note: (n: string) => `音名 ${n}`,
    right: '太神了！完全聽對！',
    wrong: (n: string) => `答案是 ${n} 喔，再接再厲！`,
  },

  catchBall: {
    title: '操場外野接高飛球',
    text: (wind: string) => `遠方擊出一記高飛球，在空中劃出拋物線！風${wind}。`,
    winds: { left: '往左吹', right: '往右吹', none: '幾乎沒有吹' },
    left: '向左快跑',
    right: '向右快跑',
    stay: '原地不動等待落點',
    caught: '美技接殺！滿場歡呼！',
    missed: '球掉在身旁，差一點！',
  },

  board: {
    title: '公佈欄',
    text: '上面釘著一張公告：「輔導小天使請到輔導室集合。待人友善、注意安全、需要時記得求助。」',
  },

  bench: {
    text: '樹下的一張木頭長椅。',
    rest: '坐下來聽聽鳥叫聲（心情回復）',
    restToast: '微風吹過樹葉沙沙作響，好平靜。',
  },

  oven: {
    title: '廚房・烘焙烤箱',
    text: '烤箱裡亮著溫暖的橙黃光芒，料理台上放著麵粉與奶油。',
    cookies: '🍪 烘焙蔓越莓手工餅乾',
    cookiesWork: '攪拌麵粉奶油、加入蔓越莓，放入烤箱烘烤……',
    cookiesDone: '叮！烤好了！獲得 3 份蔓越莓手工餅乾！',
    cake: '🍰 烘焙草莓戚風蛋糕',
    cakeNeeds: '要先有草莓才行，去福利小舖買一些吧。',
    cakeWork: '打發蛋白霜、烘烤戚風蛋糕體、抹上香濃鮮奶油……',
    cakeDone: '太香了！草莓戚風蛋糕出爐囉！',
  },

  mom: {
    lines: [
      '媽媽溫柔地摸摸你的頭：「放學累不累？今天在學校過得好嗎？」',
      '媽媽笑瞇瞇地看著你：「今天玄關收拾得真乾淨，你越來越懂事了！」',
      '媽媽正在摺衣服：「今天晚餐有想吃什麼嗎？媽媽多準備你喜歡的菜！」',
    ],
    giveCake: '🎁 送媽媽草莓戚風蛋糕',
    giveCakeNone: '背包裡還沒有蛋糕喔！快去烤箱做一個！',
    giveCakeReply: '天哪！這是你親手為媽媽做的蛋糕嗎？太好吃了……媽媽真的好幸福好感動！',
    giveCookies: '🎁 送媽媽手工餅乾',
    giveCookiesNone: '背包裡沒有餅乾喔，快去烤箱烘烤！',
    giveCookiesReply: '好酥脆的餅乾！謝謝寶貝，真貼心！',
    hug: '抱抱媽媽：「媽媽辛苦了，我愛您！」',
    hugReply: '乖孩子，媽媽只要看到你健康快樂、懂事自律，就是最大的欣慰！',
    tired: '媽媽笑著說：「今天已經抱過囉，快去休息吧，寶貝。」',
    helpOpt: '媽媽，有什麼需要我幫忙的嗎？',
    letter: '可以幫媽媽把這封信拿給李奶奶嗎？她通常在公園的池塘邊。',
  },

  shoes: {
    text: '放學回到家，先把鞋子脫下、把書包放好。',
    act: '把鞋子擺放整齊、書包掛好',
    done: '書包與鞋子歸位整齊！媽媽看在眼裡好欣慰！',
  },

  sink: {
    text: '水槽裡有吃完的午餐便當盒與晚餐碗盤。',
    act: '細心清洗碗盤與便當盒',
    done: '碗盤洗得亮晶晶！媽媽直誇你懂事貼心！',
  },

  sister: {
    text: '妹妹抱著玩具跑過來：「哥哥／姐姐～你回來了！」',
    read: '拿出繪本講故事給她聽',
    readNoBook: '你沒有繪本，去輔導室的書架借一本吧。',
    readDone: '妹妹聽故事聽得咯咯笑！媽媽在門邊露出慈祥的微笑。',
    puzzle: '陪妹妹一起玩滑塊拼圖',
  },

  homeDesk: {
    text: '乾淨的桌面，檯燈柔和地亮著。',
    act: '寫作業，再做英文跟讀',
    done: '今日功課全部完成！媽媽超驕傲！',
  },

  bath: {
    text: '熱氣騰騰的熱水澡，能洗去一整天的疲憊。',
    shower: '洗熱水澡，換上乾淨睡衣',
    showerDone: '洗完澡香噴噴、一身乾淨舒爽！',
    toilet: '上廁所',
  },

  dad: {
    hello: '爸爸鬆開領帶：「說好要回家吃晚餐，爸爸做到了！」',
    hug: '給爸爸一個大擁抱',
    hugReply: '這是最棒的歡迎回家。',
  },

  xiaoyu: {
    title: '小宇・八年級',
    open: '……我今天真的不想進教室。',
    sitDown: '先在這裡陪我坐一下吧。要不要喝杯熱可可？',
    tired: '……昨天爸媽又吵到很晚，我好累，也好害怕。',
    safe: '這裡很安全，你想待多久都可以，我會陪著你。',
    english: '那我們一起唸句英文，轉換一下心情好嗎？',
    better: '……謝謝你，我現在感覺好多了。第二節我會試著回教室。',
    promise: '我們約好，午休後再來聊聊，好嗎？',
    done: '小宇開始信任你了。',
    candy: '送他一顆喉糖',
    candyNone: '你身上沒有喉糖。',
    candyDone: '小宇接過喉糖，點點頭。',
    later: '小宇走回教室時，輕輕跟你揮了揮手。',
    satHello: '……啊，嗨。我今天不想待在家，就在這裡坐坐。',
    satInvite: '我和 Emma 要去野餐，要不要一起來？',
    satAccept: '真的嗎？要是 Emma 也說好的話……',
    satJoined: '好久沒有這麼開心的週末了。謝謝你。',
    askEmma: '小宇可以一起來野餐嗎？',
    emmaYes: 'Of course! The more the merrier. I’ll save him a sandwich!',
  },

  teacher: {
    before: '你有看到小宇嗎？他早上沒有進班，我很替他擔心。',
    report: '報告林老師：小宇心情已經平靜下來，第二節會回教室',
    thanks: '太感謝你了！有你們這些輔導小天使，真的讓人安心許多。',
    after: '再次謝謝你今天照顧小宇。',
  },

  chunbo: {
    title: '春伯・學校警衛',
    versions: [
      {
        intro: '年輕人早啊！學校巡邏一切正常，有空來喝杯茶！',
        give: '春伯早！請您喝點熱的',
        learn: '請教春伯校園周邊的安全觀念',
      },
      {
        intro: '剛才有可疑的陌生人在校門口發廣告傳單，我已經把他勸離了，大家一定要保護好自己！',
        give: '謝謝春伯保護我們！送您一點小點心',
        learn: '聽春伯分享怎麼應對陌生人',
      },
      {
        intro: '今天天氣真好啊！看你們年輕人充滿活力，我也覺得年輕了好幾歲！',
        give: '春伯今天也神采奕奕！送您一份小禮物',
        learn: '跟春伯聊聊最近中庭的花草',
      },
    ],
    gotTea: '春伯喝了熱茶，笑得合不攏嘴！',
    gotCandy: '春伯含了喉糖：「啊，喉嚨好舒服！」',
    gotNothing: '你給了春伯一個熱情的招手問候。',
    hungryOpt: '春伯，您看起來好累，還好嗎？',
    hungry: '哈哈，被你發現啦！我沒吃早餐，又不能離開校門，肚子咕嚕咕嚕叫……',
    riceAccept: '我去便利商店幫您買個飯糰！',
    riceGive: '把飯糰交給春伯 🍙',
    riceThanks: '哎呀，還熱熱的！你真是我的救星。有空隨時來警衛室坐坐！',
    tipTitle: '春伯的經驗談',
    tip: '有陌生人主動搭訕不要理會，也絕對不要拿來路不明的零食飲料。安全第一！',
    remember: '記住了！',
  },

  emma: {
    lines: [
      'Hey! Want to practice English pronunciation together?',
      'Hi! Did you listen to the English radio today? The music was awesome!',
      'Good morning! Have you finished your homework? We can study together!',
    ],
    picnicLine: 'You came! I brought a blanket and juice. Did you bring anything to share?',
    english: 'Sure！一起來做影子跟讀',
    radio: '一起聽英文廣播',
    cookies: '送她手工餅乾',
    cookiesNone: '背包裡沒有餅乾喔，快回家烤一些！',
    cookiesReply: 'Wow, homemade cookies! They smell incredible! Thank you!',
    picnicShare: '分享你親手烤的餅乾',
    picnicNone: '你還沒有東西可以分享……先回家烤餅乾吧！',
    picnicTitle: '🧺 假日草地野餐',
    picnicDone: '你和 Emma 在草地上一邊聽音樂一邊分享餅乾，真是完美的午後！',
    absent: 'Emma 現在不在這裡。',
  },

  calls: {
    incoming: '來電',
    answer: '接聽 🟢',
    decline: '掛斷 🔴',
    declined: '已掛斷通話。',
    pool: {
      scamStock: {
        caller: '【未知來電】飆股投資顧問',
        desc: '來電顯示：0982-xxx-xxx（理財推銷）',
        intro: '喂您好！我們是國際頂級投顧，保證每週獲利 30%！現在加入聊天群組就送飆股名牌，機會稍縱即逝！',
        good: '掛斷並撥打 165 反詐專線檢舉',
        goodMsg: '非常警覺！這是典型的投資詐騙陷阱！',
        bad: '心動詢問：「真的穩賺不賠嗎？」',
        badMsg: '危險！高報酬往往伴隨詐騙陷阱，差點洩漏帳戶！',
      },
      scamGame: {
        caller: '【可疑來電】遊戲客服中心',
        desc: '聲稱免費贈送限定傳說造型',
        intro: '親愛的玩家！恭喜您抽中限定傳說造型！請提供遊戲帳號密碼與簡訊驗證碼，以便客服代為領取入庫！',
        good: '拒絕透露並掛斷電話',
        goodMsg: '很棒！官方人員絕不會索取密碼與驗證碼！',
        bad: '照著念出收到的驗證碼',
        badMsg: '糟糕！驗證碼給出後帳號馬上被盜了！',
      },
      insurance: {
        caller: '【生活來電】安心人壽理財專員',
        desc: '電話推銷儲蓄保險',
        intro: '同學您好！耽誤您兩分鐘，我們推出這款高分紅儲蓄險，現在投保還送精美禮品喔！',
        good: '「謝謝，我目前未成年，會和家長討論。」',
        goodMsg: '應對得體！理財決定要和家人一起審慎評估。',
        bad: '不耐煩大罵後掛斷',
        badMsg: '情緒有些急躁……心情往下掉了。',
      },
      mom: {
        caller: '媽媽 ❤️',
        desc: '溫暖的家庭關懷來電',
        intro: '寶貝～外面天氣好像變涼了，有沒有記得多帶一件外套？午餐有沒有吃飽飽呀？',
        good: '「有喔媽媽！我有吃飽穿暖，您也要照顧好身體！」',
        goodMsg: '媽媽心都融化了，你感受到了家的溫暖。',
        bad: '「哎呀好啦我知道啦，在忙先掛了。」',
        badMsg: '媽媽在電話那頭輕輕嘆了口氣……',
      },
      friend: {
        caller: '死黨 小傑 🏀',
        desc: '好友課後熱情來電',
        intro: '喂！放學後體育館有空檔！要不要一起來練投三分球？我帶了新買的籃球！',
        good: '「好啊！球場見！」',
        goodMsg: '友誼萬歲！熱血沸騰！',
        bad: '「我想先完成輔導小天使的任務，明天再約？」',
        badMsg: '負責任的選擇！小傑說明天再約！',
      },
    },
  },

  phone: {
    tabs: { chats: '💬 訊息', calls: '📞 通話', feed: '🌐 動態', radio: '📻 廣播' },
    chatsTitle: '訊息清單',
    placeholder: '輸入訊息…',
    now: '剛剛',
    yesterday: '昨天',
    send: '傳送',
    stickers: '貼圖',
    defaultReply: '收到你的訊息了！今天也要加油喔！',
    chats: {
      family: {
        name: '相親相愛一家人 (4)',
        preview: '爸爸傳了早安長輩圖',
        msgs: [
          { from: '爸爸', text: '@card' },
          { from: '媽媽', text: '出門在外注意安全，今天大家也要順心喔！' },
          { from: '妹妹', text: '早安！你回家可以陪我玩嗎？' },
        ],
        choices: [
          '回覆：早安！今天我會準時回家吃晚飯！',
          '回傳早安長輩圖 🌸',
          '回覆妹妹：晚上等我，我唸繪本給你聽，再陪你拼拼圖！',
        ],
        r1: [
          { from: '媽媽', text: '好～媽媽多煮一道你愛吃的菜！' },
          { from: '爸爸', text: '爸爸也會準時回家！' },
        ],
        r1more: '太棒了，好期待晚上的家常菜！',
        cardReply: { from: '爸爸', text: '哈哈！這張圖好漂亮～願你今天充滿元氣！' },
        r3: [
          { from: '妹妹', text: '好耶！最喜歡你了！🎉' },
          { from: '媽媽', text: '你們感情真好，真懂事！' },
        ],
        replies: ['收到！今天全家都要平安健康！', '好～大家都要開心度過這一天！'],
      },
      friends: {
        name: '死黨群組 (3)',
        preview: '小傑：週末要野餐還是打球？',
        msgs: [
          { from: '小傑', text: '週末到底要去草地野餐還是打球啊？🏀' },
          { from: '小雨', text: '我想去野餐！有人會帶好吃的點心嗎？🍰' },
          { from: '阿明', text: '大家別忘了關心一下八年三班的小宇喔！' },
        ],
        choices: [
          '回覆小雨：我會烤蔓越莓餅乾帶去野餐！',
          '回覆阿明：小宇在輔導室安頓好了，別擔心！',
          '回覆小傑：野餐完再去球場三對三！',
        ],
        r1: [
          { from: '小雨', text: '哇！太期待了！你是烘焙大師！🍰' },
          { from: '小傑', text: '吃飽再去打球，完美的週末計畫！' },
        ],
        r2: { from: '阿明', text: '太感謝你了！有你在輔導室真可靠！' },
        r3: { from: '小傑', text: '一言為定！這週末太充實了！' },
      },
      mom: {
        name: '媽媽 ❤️',
        preview: '記得喝水吃早餐',
        msgs: [
          { from: '', text: '天冷記得穿外套，午餐要吃飽喔。' },
          { from: '', text: '放學如果晚回家，傳個訊息跟媽媽說一聲。' },
        ],
        choices: ['回覆：好的媽媽 ❤️ 我會乖乖吃飽，放學準時回家！', '回傳早安長輩圖 🌸'],
        r1: '乖孩子！路上小心喔！',
        replyMorning: '早安！記得多喝溫水吃早餐喔！',
        replyLove: '媽媽也愛你！晚上早點回家喔 ❤️',
        replyOther: '好～媽媽知道了，在學校好好照顧自己！',
        kwMorning: ['早', '吃', '餐', '飯'],
        kwLove: ['愛', '❤'],
      },
      emma: {
        name: 'Emma',
        preview: 'Shadowing practice?',
        msgs: [{ from: '', text: 'Hey! Ready for some shadowing practice?' }],
        choices: ['好啊！現在就來練習。', '可以給我一個比較難的單字嗎？'],
        r1me: 'Yes! I’m opening the shadowing notebook now!',
        r1: 'Awesome! Let’s aim for perfect! 💪',
        r2me: 'Can you give me a challenging word to practice?',
        r2: 'Try “responsibility” and “resilient”! 🌟',
        replies: ['Got your message! Let’s keep learning!', 'Awesome! Practice makes perfect!'],
      },
    },
    card: [
      { top: '🌸😊🌸', big: '早　安', sub: '以微笑打開每一天\n平安健康好運天天來' },
      { top: '☀️🌻✨', big: '平安喜樂', sub: '願你今天事事順心\n元氣滿滿　充滿力量' },
    ],
    stickerLines: ['🌸 祝你有美好的一天！', '☀️ 送你滿滿陽光！', '🌈 好運連連！', '❤️ 愛你們', '💪 今天也要一起加油！', '👍 好喔！', '😂 哈哈哈！', '🙏 謝謝！'],
    callList: {
      title: '📞 通訊錄',
      mom: { name: '媽媽', sub: '家庭溫馨通話' },
      dad: { name: '爸爸', sub: '提醒早點回家吃晚飯' },
      friend: { name: '死黨 小傑', sub: '相約假日出遊打球' },
      hotline: { name: '165 反詐專線', sub: '詐騙求證專線' },
    },
    call: {
      connecting: '接通中……',
      inCall: '通話中',
      hangUp: '🔴 掛斷電話',
      mom: {
        line: '喂？寶貝呀，今天放學路上注意安全，晚餐媽媽準備了你最愛吃的菜喔！',
        a: '「媽媽，我已經在回家路上了！」',
        b: '「媽媽我愛您，等等回去幫忙擺碗盤、洗碗！」',
        ra: '好～媽媽等你回來，路上慢點走喔！',
        rb: '哇，真是個懂事的好孩子！媽媽好欣慰！',
      },
      dad: {
        line: '喂？寶貝呀，爸爸剛開完會，有什麼事嗎？',
        a: '「爸，今天準時回來跟我們一起吃晚餐喔！」',
        b: '「爸爸辛苦了，工作別太累，早點回家！」',
        reply: '好！聽到你打來催，爸爸這就收拾公事包回家吃晚餐！',
      },
      friend: {
        line: '喂！週末大家說要去草地野餐和打球，你有沒有準備你的拿手烘焙點心？',
        a: '「當然有！蔓越莓餅乾馬上就好！」',
        b: '「沒問題，週末球場不見不散！」',
        reply: '太讚了！大家都在群組等著你，週末嗨起來！',
      },
      hotline: {
        line: '您好，這裡是 165 反詐諮詢專線。凡是莫名其妙的扣款，或陌生人要求提供帳號密碼，都是詐騙手法！',
        a: '「收到，我會時刻提高警覺！謝謝警察叔叔！」',
        reply: '非常棒的防詐素養！祝您一天平安順心！',
      },
    },
    feed: {
      brand: 'PixelBook',
      tagline: '兒少網路隱私防護',
      post: '📷 發照片貼文',
      rules: '🛡️ 自我保護守則',
      report: '🔒 檢舉並封鎖',
      interact: '點擊互動',
      reported: '✅ 已成功檢舉並封鎖',
      like: '👍 按讚',
      liked: '❤️ 已按讚',
      comment: '💬 留言',
      commented: '已在留言區回覆小雨！',
      reportOk: '正確！成功保護自己與朋友的安全！',
      reportBad: '危險行為！隨意點擊可疑連結很容易受騙！',
      likeOn: '已按讚！',
      likeOff: '取消按讚',
      posts: {
        scam1: {
          author: '陌生人「遊戲神豪」',
          time: '5 分鐘前',
          tag: '⚠️ 陌生加好友警示',
          content: '哈囉！加我好友免費送你 5000 遊戲點數，快私訊我登入畫面的截圖喔！',
        },
        scam2: {
          author: '好康社團「免費送手機」',
          time: '25 分鐘前',
          tag: '⚠️ 釣魚詐騙警示',
          content: '限時特惠！點擊連結填寫家長電話與信用卡號，即可免費抽手機！',
        },
        rain: {
          author: '死黨 小雨 📚',
          time: '1 小時前',
          tag: '🌿 校園日常動態',
          content: '今天在圖書館複習英文單字好充實！週末大家要一起去草地野餐嗎？🥪',
        },
        mine: {
          author: '我',
          time: '剛剛',
          tag: '🍰 美食烘焙日常',
          content: '放學自己動手烤的草莓戚風蛋糕出爐囉！全家吃得好開心～',
        },
      },
      photoTitle: '📷 發布照片貼文',
      photoText: '選擇你想分享的照片（注意個人隱私保護喔！）：',
      photoCake: '🍰 剛烤好的草莓戚風蛋糕',
      photoCakeDone: '發布成功！朋友們紛紛為你按讚！',
      photoDoor: '🏠 我家大門口和清楚的門牌號碼',
      warnTitle: '⚠️ 自我保護安全警告！',
      warnText: '貼文【絕對不要】拍到自家門牌地址、社區大門或鑰匙！有心人士可能藉此找到你住的地方！',
      warnFix: '遮住門牌號碼，改發校園風景照',
      warnFixed: '太棒了！你保護好了自己的住址！',
      rulesTitle: '🛡️ 網路安全守則',
      rulesText: '**1. 不隨意加好友。** 網路上陌生人的帳號可能是假的。\n\n**2. 絕不洩漏個資。** 真實姓名、電話、住家地址、學校班級絕不公開在網路上。\n\n**3. 帳號密碼是祕密。** 任何用「免費送虛寶」索取密碼或驗證碼的都是詐騙。\n\n**4. 感覺怪怪立刻求助。** 馬上告訴爸爸媽媽或老師。',
      rulesClaim: '我已經記住了！（+5⭐）',
    },
    radio: {
      title: '📻 線上學習廣播電台',
      text: '選擇你想收聽的內容（會開啟 YouTube）：',
      a: { name: 'mebook888 每日英語廣播', sub: '生活會話與英聽練習' },
      b: { name: '精選英語流行樂清單', sub: '輕快旋律、隨口哼唱' },
      c: { name: '兒少科普知識英文頻道', sub: '一邊學科學一邊學英文' },
      opened: '已在新分頁開啟。',
    },
  },

  english: {
    title: '📚 英文影子跟讀',
    hint: '🔊 聽示範 ➔ 🎤 開口跟讀 ➔ ✅ 獲得星星',
    listen: '🔊 發音',
    practice: '🎤 跟讀練習',
    sayIt: (w: string) => `請清楚大聲念出：**${w}**`,
    listening: '🎤 聆聽中……請念出這個單字',
    heard: (s: string) => `我聽到：「${s}」`,
    match: '發音很標準！',
    noMatch: '差一點點，再聽一次示範重試看看。',
    selfCheck: '✅ 我念清楚了',
    tryMic: '🎤 用麥克風檢查',
    again: '🔁 再聽一次',
    noMic: '無法使用麥克風，請用自我確認按鈕。',
    meanings: {
      responsibility: '責任',
      empathize: '同理',
      discipline: '自律',
      resilient: '有韌性的',
      boundary: '個人界限',
      procrastinate: '拖延',
      cyberbullying: '網路霸凌',
    },
  },

  blocks: {
    title: '🧱 方塊堆疊',
    score: '分數',
    lines: '消除行',
    level: '等級',
    next: '下一個',
    restart: '重新開始',
    quit: '離開',
    over: '遊戲結束',
    cleared: (n: number) => `消除 ${n} 行！`,
    quad: '💥 四行全消！',
    capped: '這個遊戲今天的星星已達上限，盡情玩樂吧！',
    final: (score: number) => `總分：${score}`,
  },

  puzzle: {
    title: '🧩 像素滑塊拼圖',
    hint: '點擊空格旁的方塊移動，拼出 1～8 的順序！',
    shuffle: '重新洗牌',
    moves: (n: number) => `步數：${n}`,
    solved: '🎉 拼圖成功！',
  },

  radio: {
    title: '📻 英文廣播',
  },

  party: {
    title: '🎂 歡樂生日派對',
    text: '要幫誰慶祝生日呢？（每場派對都需要一個蛋糕！）',
    me: (d: string) => `🎉 我的生日派對（${d}）`,
    mom: (d: string) => `💐 媽媽的生日派對（${d}）`,
    dad: (d: string) => `👔 爸爸的生日派對（${d}）`,
    emma: (d: string) => `👭 Emma 的生日派對（${d}）`,
    date: (m: number, d: number) => `${m}月${d}日`,
    needCake: '派對需要一個蛋糕，快去烤箱烤一個吧！',
    done: '這個生日已經慶祝過囉！',
    meTitle: '🎂 我的專屬生日派對',
    meText: '爸爸、媽媽、妹妹、Emma 和小傑全都到齊了！桌上擺著點燃蠟燭的草莓戚風蛋糕，大家一起為你拍手合唱生日快樂歌！🎶',
    meWish: '🌟 閉上眼睛許願',
    meBlow: '你吹熄了蠟燭，大家齊聲歡呼！媽媽送上禮物，爸爸笑著摸摸你的頭，妹妹搶著要吃第一顆草莓！',
    meThanks: '謝謝大家！我好幸福！💖',
    meVoice: '寶貝生日快樂！快許願吹蠟燭吧！',
    momTitle: '💐 媽媽的感恩生日派對',
    momText: '你悄悄烤好了草莓戚風蛋糕，點上溫暖的蠟燭。全家為媽媽唱生日快樂歌，送上手寫卡片：「謝謝您一直照顧我們！」',
    momAct: '親手切第一塊蛋糕餵媽媽吃',
    momVoice: '謝謝寶貝！這是媽媽收過最棒的生日禮物！',
    momDone: '媽媽感動得眼角泛淚，給你一個長長的擁抱。',
    dadTitle: '👔 爸爸的溫馨生日派對',
    dadText: '爸爸準時回家了！餐桌上擺滿熱騰騰的家常菜，全家戴著生日帽，還有你親手烤的蛋糕。',
    dadAct: '「爸爸生日快樂！工作辛苦了！」',
    dadVoice: '哈哈！謝謝你！爸爸再忙都值得了！',
    dadDone: '爸爸開懷大笑，全家感情從來沒有這麼好過！',
    emmaTitle: '👭 Emma 的野餐生日會',
    emmaText: '週末草地上陽光燦爛，鋪好野餐墊、擺上自製點心，大家一起為 Emma 慶祝生日！',
    emmaAct: '送上蛋糕與賀卡',
    emmaVoice: 'Thank you so much! You’re my best friend!',
    emmaDone: 'Emma 超級開心！',
  },

  map: {
    names: { town: '小鎮', school: '學校', home: '家', store: '街角便利商店' },
    you: '你',
    goal: '目標',
    people: '人物',
    doors: '出入口',
  },

  quests: {
    title: '任務',
    started: '新任務',
    completed: '任務完成',
    active: '進行中',
    available: '可接取',
    done: '已完成',
    track: '追蹤',
    tracking: '追蹤中',
    none: '還沒有任務喔。到鎮上找大家聊聊天吧！',
    clover: (n: number, total: number) => `🍀 幸運草 ${n}/${total}`,
    lapsDone: (secs: number) => `🏁 ${secs} 秒跑完所有旗子！快去告訴教練。`,
    lapsFail: '⏱ 時間到！再找徐教練挑戰一次吧。',
    list: {
      atlas: {
        title: '消失的地圖集',
        desc: '王阿姨那本大大的世界地圖集，從圖書館不見了。',
        steps: ['到圖書館和王阿姨說話', '到八年三班找找地圖集', '把地圖集還給王阿姨'],
      },
      riceBall: {
        title: '肚子餓的警衛伯伯',
        desc: '春伯為了顧校門，連早餐都沒吃。',
        steps: ['到校門口和春伯說話', '到街角便利商店買一個飯糰', '把飯糰送去給春伯'],
      },
      laps: {
        title: '和時間賽跑',
        desc: '徐教練挑戰你在一分鐘內跑過跑道上的每一支旗子。',
        steps: ['到操場和徐教練說話', '依序跑過 4 支旗子', '告訴徐教練你成功了'],
      },
      study: {
        title: '讀書好夥伴',
        desc: '小雨想和你一起練習英文單字。',
        steps: ['到圖書館和小雨說話', '練習 3 個不同的單字（影子跟讀）', '告訴小雨練習成果'],
      },
      kitten: {
        title: '麻糬在哪裡？',
        desc: '李奶奶的小貓跑進公園裡不見了。',
        steps: ['到公園和李奶奶說話', '搜一搜公園的樹叢，仔細聽沙沙聲', '把麻糬帶回李奶奶身邊'],
      },
      kite: {
        title: '卡在樹上的風箏',
        desc: '小寶的風箏卡在住宅區的大樹上了。',
        steps: ['到住宅區和小寶說話', '搖一搖大樹（要搖三次！）', '把風箏還給小寶'],
      },
      xiaoyuPicnic: {
        title: '野餐的空位',
        desc: '週六，小宇一個人坐在公園裡。',
        steps: ['到公園和小宇說話', '問 Emma 小宇能不能一起野餐', '問 Emma 小宇能不能一起野餐'],
      },
      letter: {
        title: '使命必達',
        desc: '媽媽有一封信要給李奶奶。',
        steps: ['問媽媽需不需要幫忙', '到公園把信交給李奶奶', '到公園把信交給李奶奶'],
      },
      clovers: {
        title: '幸運草',
        desc: '小鎮、學校和家裡都藏著四葉幸運草。',
        steps: ['留意閃閃發亮的幸運草', '找出所有的幸運草', '找出所有的幸運草'],
      },
      postcards: {
        title: '給奶奶的明信片',
        desc: '李奶奶從沒去過大城市。幫她從臺北三個地標帶明信片回來。',
        steps: ['在公園跟李奶奶說話', '在臺北車站、龍山寺和自由廣場收集明信片', '把明信片交給李奶奶'],
      },
      pineapple: {
        title: '臺北的鳳梨酥',
        desc: '媽媽想要一盒正港的臺北鳳梨酥，招待來喝茶的奶奶。',
        steps: ['在家跟媽媽說話', '向臺北的店員買鳳梨酥', '把鳳梨酥交給媽媽'],
      },
      elephant: {
        title: '象山上的照片',
        desc: '艾瑪想要一張從象山頂上拍的臺北 101 照片。',
        steps: ['在家跟艾瑪說話', '請象山觀景台的登山客幫忙拍照', '把照片拿給艾瑪看'],
      },
      mochi: {
        title: '花蓮麻糬',
        desc: '小波願意用最好的彈珠換一盒軟 Q 的花蓮麻糬。',
        steps: ['在社區跟小波說話', '向花蓮的麻糬阿姨買麻糬', '把麻糬交給小波'],
      },
      pebble: {
        title: '七星潭的石頭',
        desc: '小雨的石頭收藏還缺一顆七星潭海灘的石頭。',
        steps: ['在圖書館跟小雨說話', '向七星潭海灘的漁夫要一顆石頭', '把石頭交給小雨'],
      },
    },
  },

  library: {
    hello: '噓……歡迎來到圖書館，慢慢看喔。',
    ask: '哎呀，我們那本大大的世界地圖集不見了，應該是哪個同學借去上地理課，忘在教室裡了。可以幫我找找嗎？',
    accept: '沒問題，我來找！',
    hint: '八年三班今天早上有地理課，去他們的課桌找找看！',
    thanks: '你找到了！謝謝你。來，送給圖書館最棒的小幫手一點小禮物。',
    found: '在課桌底下，被書包遮住了一半……是那本世界地圖集！',
    deskNothing: '一張學生課桌，角落刻著塗鴉。',
    shelfText: '百科全書、漫畫、詩集……書架上飄著舊書的紙香。',
    read: '看一會兒書（學力 +10）',
    readToast: '你學到了關於章魚的新知識：牠們有三顆心臟！',
  },

  vending: { text: '玻璃後面擺著色彩繽紛的飲料，機器輕輕嗡嗡作響。', buy: '買一瓶鋁箔包果汁', bought: '咚！一瓶鋁箔包果汁掉了出來。' },
  canteen: {
    text: '今日午餐：白飯、滷豆腐、燙青菜和湯。',
    closed: '午餐供餐時間是 11:30 到 13:30。',
    lunch: '吃午餐（精力 +30）',
    lunchDone: '熱騰騰又吃得飽飽的，下午也有精神了！',
  },
  busStop: {
    text: '8 路公車——開往火車站。下一班車還有 12 分鐘。',
    where: '8 路公車停靠站。你想去哪裡？（用英文問問看：“Does this bus go to the mall?”）',
    stops: { busStopW: '西站——便利商店、公園、家', busStop: '學校', busStopE: '東站——運動中心、購物中心' },
    here: '📍 你在這裡',
    notNow: '先不用',
    beep: '🚌 嗶！你刷了悠遊卡，上車囉。',
    arrived: (name: string) => `🚏 ${name}到了。“Thank you, driver!”`,
    night: '末班車已經開走了（公車行駛時間 6:00–22:00）。只好走路囉！',
  },
  mailbox: {
    postcard: '爺爺寄來的明信片！「今天去看海了。要乖、要用功，青菜也要吃喔。」',
    empty: '信箱空空的。',
  },
  pond: { text: '橘色的魚兒在睡蓮葉下悠游。', feed: '餵魚（心情回復）', feedToast: '魚兒們聚成一團橘色的漩渦！' },
  bush: { text: '一叢茂密的樹叢。' },
  kitten: {
    found: '葉子裡蜷著一團白白的東西……是麻糬！小貓喵了一聲，跟著你走。',
    notHere: '你撥開葉子……只有一隻嚇了一跳的甲蟲。',
  },
  kite: {
    hello: '我的風箏是整條街飛得最高的！',
    ask: '我的風箏卡在大樹上了！我太矮搆不到……你可以幫幫我嗎？',
    accept: '交給我吧！',
    waiting: '用力搖那棵樹！就是步道旁邊那棵大樹。',
    thanks: '我的風箏！你最棒了！來，請你吃糖果！',
    after: '你看，飛得好高喔！',
    treeText: '一棵樹幹粗壯的老大樹。',
    treeAfter: '樹枝輕輕搖晃，上面已經沒有風箏了。',
    shakeMore: (n: number) => `樹枝晃動……風箏搖搖欲墜！（還要 ${n} 次）`,
    fell: '最後用力一搖，風箏輕飄飄地落進你手裡！',
  },
  swing: { text: '一座鞦韆，鐵鍊被太陽曬得暖暖的。', play: '盪一下鞦韆', toast: '咻～越盪越高！' },
  fridge: { text: '有剩菜、水果，還有一個寫著你名字的布丁。', snack: '吃點心（精力 +12）', snackToast: '好好吃！媽媽做的布丁最棒了。' },
  tv: { text: '電視正在播烹飪節目。', watch: '看一會兒電視', toast: '你學會了包水餃。大概啦。' },
  rain: {
    hello: '嗨！圖書館是我最喜歡的地方。',
    offer: '要不要當讀書好夥伴？練習三個英文單字，再來跟我說練得怎麼樣！',
    accept: '一言為定！',
    waiting: (n: number) => `練得怎麼樣？你今天已經練了 ${n}/3 個單字。`,
    done: '太厲害了！你的發音越來越好了！',
    sat: '週六的公園！你有看到池塘裡的魚嗎？',
  },
  coach: {
    hello: '大家膝蓋抬高！',
    offer: '你看起來跑得很快！一分鐘內依序跑過跑道上的四支旗子，準備好了嗎？',
    retry: '要不要再挑戰一次？四支旗子，一分鐘！',
    accept: '準備好了！',
    go: '🏁 開始！跟著旗子跑！',
    running: '衝衝衝！跟著旗子跑！',
    done: '跑得好！就是要這種精神！',
    after: '今天辛苦了，記得做伸展喔！',
  },
  clerk: {
    lines: ['歡迎光臨！剛到了新鮮的飯糰喔。', '又見面了！需要什麼嗎？', '現在是草莓季，超級甜喔！'],
    shop: '🛒 來逛逛吧',
  },
  grandma: {
    lines: ['鴿子都認得我了，咕咕、咕咕！', '今天天氣真好，最適合散步了。', '你讓我想起我的孫子。'],
    kittenAsk: '哎呀……我的小貓麻糬從籃子裡溜出去，跑進樹叢裡了。我的膝蓋已經不比從前了……',
    kittenAccept: '我來幫您找麻糬！',
    kittenWaiting: '仔細聽喔，如果有樹叢沙沙作響，麻糬可能就躲在裡面。',
    kittenThanks: '麻糬！哎呀，謝謝你，真是謝謝你！來，這個給你，辛苦你了。',
    letterThanks: '你媽媽寫給我的信？真是貼心。跟她說我下週帶水餃過去！',
  },
  cat: { lines: ['喵～ 🐱', '呼嚕嚕……', '貓咪在你腳邊蹭來蹭去。', '貓咪對你慢慢眨了眨眼，意思是「我喜歡你」。'] },

  talks: zhTWTalks,
  ...zhTWExtra,
  ...zhTWPlaces,
  ...zhTWArcade,
  ...zhTWTreasure,
  ...zhTWTalks3,
  ...zhTWGuide,
  ...zhTWWorld3,
  ...zhTWTrips,
  ...zhTWSky,
  ...zhTWFamily,
  ...zhTWClassroom,
  ...zhTWLife,
  ...zhTWXinyi,
  ...zhTWXimen,
  ...zhTWCks,
  ...zhTWHlcity,
  ...zhTWTaroko,
  ...zhTWStory,
  ...zhTWAirport,
  ...zhTWKaohsiung,
  ...zhTWTainan,
  ...zhTWBarcelona,

  rewards: {
    stars: (n: number) => `+${n}⭐`,
    energy: (n: number) => `+${n}⚡`,
    mood: (n: number) => `+${n}💚`,
    study: (n: number) => `+${n}📄`,
    coins: (n: number) => `+${n}🪙`,
    love: (n: number) => `+${n}💖`,
    got: (what: string) => `獲得 ${what}`,
  },
};
